import {connect} from 'react-redux';
import ExplorerTheme from './ExplorerTheme';

const mapStateToProps = state => ({
    primaryColors: state.pageState.layout?.config?.settings?.brandingConfig?.primary?.colors
        ? state.pageState.layout?.config?.settings?.brandingConfig?.primary?.colors
        : {text: '#FFFFFF', background: '#1492FF'},
});

export default connect(mapStateToProps)(ExplorerTheme);
